import React from 'react';
import { Col, Row, Alert } from 'reactstrap';
import PropTypes from 'prop-types';
import { Form, Field } from 'react-final-form';
// import { LinkContainer } from 'react-router-bootstrap';
import NFButton from '../../primitives/NFButton';
// import Loading from '../../Loading';
import { orgDetailsConfig, contactConfig } from './formConfig';
import './NewOrganization.scss';
// import { superAdminHomeRoute } from '../../../config/navigation/routes';
// import { requestUserByEmail } from '../../../graphql/users';
// import { organizationInDB } from '../../../graphql/organizationDetails';
import { isCageEditable } from '../../../utils/validationUtils';
// import history from '../../../config/history';

export default class NewOrganization extends React.PureComponent {

  static initialState = {};
  state = NewOrganization.initialState;

  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onCountryChange: PropTypes.func.isRequired,
    onStateProvChange: PropTypes.func.isRequired,
    onFieldChange: PropTypes.func.isRequired,
    onResetForm: PropTypes.func.isRequired,
    messages: PropTypes.instanceOf(Array).isRequired,
    initialValues: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      iconStatus: PropTypes.string,
      cageCode: PropTypes.string,
      address1: PropTypes.string,
      address2: PropTypes.string,
      address3: PropTypes.string,
      zipCode: PropTypes.string,
      cntry: PropTypes.string,
      pointofContact: PropTypes.string,
      phoneNumber: PropTypes.string,
      organizationType: PropTypes.string,
      city: PropTypes.string,
      state: PropTypes.string,
      websiteUrl: PropTypes.string,
      admins: PropTypes.instanceOf(Array),
      matchSettingList: PropTypes.shape({
        materials: PropTypes.arrayOf(PropTypes.string),
        methods: PropTypes.arrayOf(PropTypes.string),
        minimumEstimatedCost: PropTypes.number,
        minimumEstimatedQuantity: PropTypes.number,
      }),
    }),

    closeEditModal: PropTypes.func.isRequired,
  };

  static defaultProps = {
    initialValues: PropTypes.shape({
      id: '',
      name: '',
      status: '',
      cageCode: '',
      address1: '',
      address2: '',
      address3: '',
      zipCode: '',
      cntry: '',
      pointofContact: '',
      phoneNumber: '',
      organizationType: '',
      city: '',
      state: '',
      websiteUrl: '',
      admins: [{ name: '', email: '' }],
      matchSettingList: [
        {
          materials: [''],
          methods: [''],
          minimumEstimatedCost: 0,
          minimumEstimatedQuantity: 0,
        },
      ],
    }),
  };

  // _onChangeCountry = (country) => {
  //   this.setState({
  //     country,
  //   });
  // };

  render() {
    const { onSubmit, initialValues, messages, onCountryChange, onStateProvChange, onFieldChange, onResetForm, closeEditModal } = this.props;
    // let name;
    // let email;
    // let phoneNumber;
    // // let approveAccepted;
    // if (initialValues.cageCode && initialValues.cageCode.startsWith("OG")) {
    //   // approveAccepted = "accepted"
    //   if (initialValues.users.length > 0) {
    //     name = initialValues.users[0].name;
    //     email = initialValues.users[0].email
    //     phoneNumber = initialValues.users[0].phoneNumber
    //   }
    // } else {
    //   // approveAccepted = "approved";
    //   if (initialValues.admins.length > 0) {
    //     name = initialValues.admins[0].name
    //     email = initialValues.admins[0].email
    //     phoneNumber = initialValues.admins[0].phoneNumber
    //   }
    // }

    const transformedInitialValues = {
      id: initialValues.id,
      organizationType: initialValues.organizationType,
      iconStatus: initialValues.iconStatus,
      name: initialValues.name,
      cageCode: initialValues.cageCode,
      address1: initialValues.address1,
      address2: initialValues.address2,
      address3: initialValues.address3,
      city: initialValues.city,
      state: initialValues.state,
      websiteUrl: initialValues.websiteUrl,
      zipCode: initialValues.zipCode,
      cntry: initialValues.cntry,
      materials: initialValues.matchSettingList
        ? initialValues.matchSettingList.materials
        : undefined,
      methods:
        initialValues.matchSettingList && initialValues.matchSettingList.methods
          ? initialValues.matchSettingList.methods.map(method =>
            method
              .split(' ')
              .map(
                (word, ind) =>
                  ind > 0
                    ? word[0].toUpperCase() + word.substring(1).toLowerCase()
                    : word,
              )
              .join(''),
          )
          : undefined,
      minimumQuantity: initialValues.matchSettingList
        ? initialValues.matchSettingList.minimumQuantity
        : 0,
      minimumEstimatedCost: initialValues.matchSettingList
        ? initialValues.matchSettingList.minimumEstimatedCost
        : 0,
      pointOfContact: initialValues.pointOfContact,
      email: initialValues.email,
      phoneNumber: initialValues.phoneNumber,
    };

    const isCageE = isCageEditable(transformedInitialValues.cageCode);



    return (
      <Form
        onSubmit={onSubmit}
        initialValues={transformedInitialValues}
        validateOnBlur
        render={({ handleSubmit, form, submitting, validating }) => (
          <React.Fragment>
            <br />
            <form className="nf-new-org-form" onSubmit={handleSubmit}>
              <div className="nf-org-message">
                If your organization is registered with the System for Award Management (SAM) then you will need to sign into <a href='https://www.sam.gov' rel='noopener noreferrer' target='_blank'>sam.gov</a> to make changes to your organization and contact details.
              </div>

              <div>
                <h3 className="nf-add-organization__header">
                  Organization Details<div className="nf-org-status">Current Status: {initialValues.iconStatus}</div>
                </h3>
                {orgDetailsConfig.map(fieldConfig => (
                  <Field
                    validateOnBlur={false}
                    key={fieldConfig.name}
                    disabled={isCageE}
                    onCountryChange={onCountryChange}
                    onStateProvChange={onStateProvChange}
                    cntry={initialValues.cntry}
                    parse={value => value}
                    onBlur={(e) => { onFieldChange(fieldConfig.name, e.target.value) }}
                    {...fieldConfig}
                  />
                ))}
                <br />
                <h3 className="nf-add-organization__header">
                  Contact Details
                </h3>
                {contactConfig.map(fieldConfig => (
                  <Field key={fieldConfig.name}
                    disabled={isCageE}
                    parse={value => value}
                    onBlur={(e) => { onFieldChange(fieldConfig.name, e.target.value) }}
                    {...fieldConfig} />
                ))}

                <Row>
                  <Col sm={{ size: 7, offset: 2 }} className="text-center">
                    {messages[0]
                      ? messages.map(message => (
                        <Alert color={message.alertType}>
                          {message.alertMessage}
                        </Alert>
                      ))
                      : null}
                    {/* <LinkContainer to={superAdminHomeRoute}> */}
                    <NFButton
                      className="nf-button--gray-border"
                      disabled={submitting}
                      onClick={() => {
                        closeEditModal();
                      }}
                    >
                      Cancel{' '}
                    </NFButton>
                    <NFButton
                      className="nf-button--gray-border"
                      disabled={submitting}
                      onClick={() => {
                        onResetForm();
                      }}
                    >
                      Reset{' '}
                    </NFButton>
                    {/* </LinkContainer> */}
                    <NFButton
                      className="nf-button--form nf-button--red-border"
                      type="submit"
                      onClick={() => {
                        form.change('iconStatus', 'denied');
                      }}
                      disabled={submitting || validating}
                    >
                      Deny
                    </NFButton>
                    <NFButton
                      className="nf-button--form nf-button--orange"
                      type="submit"
                      onClick={() => {
                        form.change('iconStatus', "approved");
                      }}
                      disabled={submitting || validating}
                    >
                      Approve
                    </NFButton>
                  </Col>
                </Row>
              </div>
            </form>
          </React.Fragment>
        )}
      />
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/forms/NewOrganizationForm/NewOrganization.jsx